export const GET_EMISSION_RESUME = 'EMISSION-GET_POLICY_RESUME';
export const UPDATE_EMISSION_VIN = 'UPDATE_EMISSION_VIN';
